import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Required to update translation on error messages
// which were provided to validation schema as already translated strings, e.g. t('key').
export const RevalidateOnLangChange = () => {
  const { i18n } = useTranslation();
  const { validateForm } = useFormikContext<any>();

  useEffect(() => {
    validateForm();
  }, [i18n.language, validateForm]);

  return null;
};
